module.exports = __webpack_public_path__ + "img/ertiga-xl7-boostergreen-glx-gris-magma.f04748e9.png";